import { login, logout, getInfo } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { resetRouter } from '@/router'

const getDefaultState = () => {
  return {
    token: getToken(),
    name: localStorage.getItem('ms-main-userName'),
    avatar: '',
    userId: localStorage.getItem('ms-main-userId'),
    adminType:localStorage.getItem('ms-main-adminType'),
    orderStatusList:[
      {name:'待支付',value:0},
      {name:'待备货',value:1},
      {name:'待取货',value:2},
      {name:'已完成',value:3},
      {name:'已取消',value:4},
      {name:'已关闭',value:5},
      {name:'退款成功',value:6},
      {name:'待配送',value:7},
      {name:'配送中',value:8},
    ],
    payModeList:[
      {name:'',value:0},
      {name:'微信小程序支付',value:1},
      {name:'微信付款码支付',value:2},
      {name:'现金',value:3},
      {name:'钱包',value:4},
      {name:'支付宝支付',value:5},
    ],
    userInfo:localStorage.getItem('ms-store-userInfo'),
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    localStorage.setItem('ms-main-userName',name)
    state.name = name
  },
  SET_USERID: (state, userId) => {
    localStorage.setItem('ms-main-userId',userId)
    state.userId = userId
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_adminType: (state, adminType) => {
    localStorage.setItem('ms-main-adminType',adminType)
    state.adminType = adminType
  },
  setCurrentSysUserInfo(state,data){
    localStorage.setItem('ms-store-userInfo',JSON.stringify(data) )
    state.userInfo=JSON.stringify(data)
  },
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password, verifyCode } = userInfo
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: password, verifyCode }).then(response => {
        const { data } = response
        console.log(data)
        commit('SET_adminType', data.adminType)
        commit('SET_TOKEN', data.token)
        commit('SET_NAME', data.name)
        commit('SET_USERID', data.id)
        setToken(data.token)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      // getInfo(state.token).then(response => {
      //   const { data } = response
      const data = {
        roles: ['admin'],
        introduction: 'I am a super administrator',
        avatar: 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif',
        name: 'Super Admin'
      }
      if (!data) {
        return reject('Verification failed, please Login again.')
      }

      const { name, avatar } = data

      commit('SET_NAME', name)
      commit('SET_AVATAR', avatar)
      resolve(data)
      // }).catch(error => {
      //   reject(error)
      // })
    })
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      removeToken() // must remove  token  first
      resetRouter()
      commit('RESET_STATE')
      resolve()
      // logout(state.token).then(() => {
      //   removeToken() // must remove  token  first
      //   resetRouter()
      //   commit('RESET_STATE')
      //   resolve()
      // }).catch(error => {
      //   reject(error)
      // })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

